import React from 'react';
import './Qhse.css';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";
import { CiEdit } from 'react-icons/ci';

const DEFAULT_DATA = {
  bannerImage:  "",
  title:        "",
  introHeading: "",
  paragraphs:   [],
  sections:     [],
};

const EXTRA_FIELDS = [
  { key: "introHeading", label: "Intro Heading", rows: 3 },
];

const SafetyPolicy = () => {
  const {
    pageData, loading, fetchErr, fetchData,
    modalOpen, setModalOpen, saving, handleSave, saveMsg,
  } = usePageEditor("/api/safety", DEFAULT_DATA);

  const bannerImg  = resolveUrl(pageData.bannerImage) || null;
  const hasContent = Boolean(pageData.title);

  return (
    <>
      <button
        title="Edit page"
        onClick={() => setModalOpen(true)}
        style={{ position: "absolute", top: 70, right: 20, zIndex: 10, background: "rgba(255,255,255,0.9)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
      >
        <CiEdit size={24} color="#333" />
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr} <button onClick={fetchData}>Retry</button></div>}

      {modalOpen && (
        <ServiceEditModal
          data={pageData}
          onSave={handleSave}
          onClose={() => setModalOpen(false)}
          saving={saving}
          pageLabel="Safety Policy"
          extraFields={EXTRA_FIELDS}
        />
      )}

      {hasContent && (
        <div style={{ padding: 20 }}>
          {bannerImg && (
            <div className="img_carrier">
              <img src={bannerImg} alt="" style={{ maxWidth: "100%" }} />
            </div>
          )}

          <h1>{pageData.title}</h1>

          {pageData.introHeading && <h2>{pageData.introHeading}</h2>}

          {pageData.paragraphs.map((para, i) => (
            <p key={i}>{para}</p>
          ))}

          {pageData.sections.map((sec, i) => (
            <div key={i}>
              <h2>{sec.heading}</h2>
              {sec.items.map((item, j) => (
                <p key={j}>{item}</p>
              ))}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default SafetyPolicy;
